import React from 'react';
import { connect } from 'react-redux';
import {
  Link,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import {
  Button,
  Layout,
} from 'antd';

import { LayoutStyle } from '@constants/Theme'
import LoginForm from '@views/Authentication/LoginForm';
import SignUpForm from '@views/Authentication/SignUpForm';
import ForgotPasswordForm from '@views/Authentication/ForgotPasswordForm';
import NotFound from './NotFound';

const routes = [
  {
    key: "/login",
    component: LoginForm,
  },{
    key: "/sign_up",
    component: SignUpForm,
  },{
    key: "/forgot_password",
    component: ForgotPasswordForm,
  },
];

class UnauthenticatedRouter extends React.Component {
  constructor(props) {
    super(props);
  }

  renderSider() {
    return (
      <Layout.Sider
      >
        <Link to="/">
          <h3
            style={{
              ...LayoutStyle.siderTitle,
              color: 'white',
            }}
          >
            { this.props.orgName }
          </h3>
        </Link>
      </Layout.Sider>
    )
  }

  render() {
    return (
      <Layout style={ LayoutStyle.outerLayoutStyle }>
        { this.renderSider() }
        <Layout.Content style={ LayoutStyle.routerContentStyle }>
          <Routes>
            <Route path="/" element={ <Navigate to={ routes[0].key } replace /> } />
            {
              routes.map((route, index) => (
                <Route
                  key={ index.toString() }
                  path={ `${route.key}/*` }
                  element={ <route.component /> }
                />
              ))
            }
            <Route path="*" element={ <Navigate to="/login" replace /> } />
          </Routes>
        </Layout.Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    orgName: state.organizationReducer.name,
  };
}

const mapDispatchToProps = (dispatch, props) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnauthenticatedRouter);
